/**
 * 공고 결제방법(카드 · 현금 · 미결정) 표시 규칙.
 *
 * 발주기관이 **공고 단계**에서 고른 희망 결제수단이다. 계약에서 확정한 값
 * (`contracts.payment_channel`)과는 다른 축이며, 화면에서 둘을 같은 배지로 그리면
 * 「확정된 값」과 「희망하는 값」이 구분되지 않는다 — 반드시 따로 그린다.
 *
 * 공급사에게 이 값이 보여야 하는 이유: **카드냐 현금이냐로 단가가 갈린다.**
 * 공고에만 적히고 견적 쓰는 화면에 안 보이면, 나중에 「업체와 상의하세요」 안내가 떠도
 * 공급사는 자기가 무슨 기준으로 견적을 냈는지 모른다.
 */

/** 서버가 내려주는 값. `null` 은 기능 신설(2026-08-19) 이전 공고다. */
export type PreferredPaymentChannel = "card" | "cash" | "undecided";

const LABELS: Record<PreferredPaymentChannel, string> = {
  card: "카드",
  cash: "현금",
  undecided: "미결정",
};

/**
 * 배지에 쓸 문구. **`null` 이면 `null` 을 돌려주고, 호출부는 행을 그리지 않는다.**
 *
 * 기능이 생기기 전 공고는 발주기관이 고른 적이 없다. 거기에 「미결정」을 그리면 고르지 않은
 * 값을 고른 것처럼 보인다 — 서버가 `undecided` 로 채우지 않고 `null` 을 그대로 내려주는
 * 것도 같은 이유다(c-market 합의, 2026-08-19).
 *
 * 모르는 값도 `null` 로 접는다. 배지 하나 때문에 목록 전체가 깨지는 것보다 낫다.
 */
export function getPaymentChannelLabel(
  channel: string | null | undefined,
): string | null {
  if (!channel) return null;
  return LABELS[channel as PreferredPaymentChannel] ?? null;
}
